<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <!-- <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Transportation Reports</b-navbar-brand>

         
        </b-navbar> -->
        <md-tabs>
          <md-tab md-icon="home" md-label="Dashboard">
            <div class="row mt-3">
              <div class="col-md-11">
                <date-range-picker class="pull-right" :opens="openLeft" :always-show-calendars="showCal"
                v-model="dateRange" :startDate="startDate" :endDate="endDate" :locale-data="locale"
                @update="viewAssignment('0', '1', '1')">
                <!--Optional scope for the input displaying the dates -->
                <!-- <div slot="input" slot-scope="picker">{{ picker.startDate }} - {{ picker.endDate }}</div> -->
              </date-range-picker>
              </div>
              <div class="col-md-1">
                <b-button style="margin-right: 5px; margin-top: 4px" size="sm" class="pull-right ml-1"
                @click="viewAssignment('0', '1', '1','clear')" variant="outline-info">Clear</b-button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-6 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-0">Top Clients</h4>
                    <p class="mb-0 ml-1 text-muted">
                      By No. of Containers Executed
                    </p>
                    <div id="chart2">
                      <apexchart type="bar" v-if="showGraph == true" height="350" :options="chartOptionsRefuel"
                        :series="seriesRefuel"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-0">Top Import Destination</h4>
                    <p class="mb-0 ml-1 text-muted">
                      By No. of Containers
                    </p>
                    <div id="chart2">
                      <apexchart type="bar" v-if="showGraph == true" height="350" :options="chartOptionsExDesti"
                        :series="seriesExDesti"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </md-tab>

          <md-tab md-icon="content_paste" md-label="Reports">
            <div class="mt-3">
              <div>
                <b-button variant="outline-dark" :class="visible ? null : 'collapsed'"
                  :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4" @click="visible = !visible">
                  Filters</b-button>

                <b-button class="pull-right" v-if="veiwVehicleBookingForm.length>0" @click="getReports" size="sm"
                  variant="warning">Export as Excel</b-button>

              </div>


              <b-collapse v-model="visible" id="collapse-2">
                <b-card class="mt-2">
                  <md-layout md-gutter class="justify-content-center">
                    <md-layout md-flex="40" md-flex-small="100" class="pl-2 pr-2">
                      <model-list-select :list="clientMaster" id="clientNamenew" v-model="clientIdFilter"
                        option-value="clientId" option-text="clientName" placeholder="Select  Client Name">
                      </model-list-select>
                    </md-layout>


                    <!-- <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20" md-flex-small="100">
                  <model-list-select
                    :list="transportTypeName"
                    v-model="transportTypeFilter"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Export / Import"
                  ></model-list-select>
                </md-layout> -->
                    <!-- <md-layout md-flex="5"></md-layout> -->
                    <md-layout md-flex="40" md-flex-small="100" class="pl-2 pr-2">
                      <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="dateRange"
                        :startDate="startDate" :endDate="endDate" :locale-data="locale"
                        @update="viewAssignment('0', '1', '1');">
                        <!--Optional scope for the input displaying the dates -->
                        <!-- <div slot="input" slot-scope="picker">{{ picker.startDate }} - {{ picker.endDate }}</div> -->
                      </date-range-picker>
                    </md-layout>
                  </md-layout>

                  <div class="mt-3 text-center">
                    <b-button size="sm" @click="filterSearch" variant="outline-primary">Search
                    </b-button>
                    <b-button size="sm" @click="clearFilter"
                      variant="outline-info">clear</b-button>
                  </div>
                </b-card>
              </b-collapse>
            </div>

            <div>
              <h5 class="text-muted pull-right mt-2 ml-3">
                <small>{{totalRows}} Entries</small>
              </h5>
            </div>



            <div class="table-responsive tableMain mt-3">
              <b-table show-empty stacked="md" :items="veiwVehicleBookingForm" :fields="fields" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                <template slot="ffImportId" slot-scope="row0">
                  <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                </template>

                <template slot="importerName" slot-scope="row11">


                  <span>Importer : {{row11.item.importerName}}<br></span>
                  <span>Exporter : {{row11.item.exporterName }}<br></span>



                  <!-- <span>Raised From : {{row1.item.EmpLoc}}</span> -->
                </template>
                <template slot="ffImportSeries" slot-scope="row1">

                  <!-- @click="viewAssignmentpage(row1.item.clientId,row1.item.salesBookingId,row1.item.quotationId,row1.item.assignId)"
              class="showMoreData"-->
                  <span>{{row1.item.ffImportSeries}}<br></span>
                  <span>{{row1.item.loginTime | moment}}<br></span>



                  <!-- <span>Raised From : {{row1.item.EmpLoc}}</span> -->
                </template>

                <template slot="placeOfReceipt" slot-scope="row21">
                  <b>Type : {{row21.item.transportType}}</b>
                  <br>
                  <b>Stuffing Type : {{row21.item.stuffingType}}</b>
                  <br>
                  <b>Shipping Line : {{row21.item.shippingLine}}</b>
                  <br>
                  <span>POR Location : {{row21.item.placeOfReceipt}}</span>
                  <br>
                  <span>Load Port Location : {{row21.item.loadPort}}</span>
                  <br>
                  <span>POD Location : {{row21.item.portOfDischarge}}</span>
                  <br>
                  <span>FPOD : {{row21.item.finalPlaceDelivery}}</span>

                </template>
                <!-- <template slot="LoadPort" slot-scope="row31">
                  <div v-if="row31.item.freightContainersType!=null">
                <b> {{row31.item.freightContainersType.split(',').length}}</b>
                  </div>
             </template> -->
                <template slot="ContainerNo" slot-scope="row3">
                  <!-- <b>Required Containers : {{row3.item.totalRequiredContCount}}</b>
             <br> -->
                  <div v-if="row3.item.ContainerNo!=null">
                    <span v-for="(item,index) in row3.item.ContainerNo.split(',')" :key="index">
                      <h6>
                        <b-badge variant="light">{{item + " "}}</b-badge>
                      </h6>
                    </span>
                  </div>
                </template>
                <template slot="containerTypeName" slot-scope="row2">
                  <div v-if="row2.item.containerTypeName!=null">
                    <div v-for="(item1,index) in row2.item.containerTypeName.split(',')" :key="index">
                      <b-badge variant="light">{{item1 + " "}}</b-badge>
                    </div>
                  </div>

                  <!-- <br>
              <span>Booked Vehicle : {{row2.item.vehicleNO}}</span> -->
                </template>
                <template slot="shippingBillNo" slot-scope="row5">

                  <div v-if="row5.item.shippingBillNo!=null">
                    <div v-for="(item1,index) in row5.item.shippingBillNo.split(',')" :key="index">
                      <span> {{item1}}</span>
                    </div>
                  </div>

                </template>

              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                @change="onPageChange($event)"></b-pagination>
            </div>
          </md-tab>


        </md-tabs>

      </b-card-text>
    </b-card>
  </div>
</template>


<script>
  import axios from "axios";
  import moment from "moment";
  import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
  import CustomLoader from "../common/customLoader.vue";
  import DateRangePicker from "vue2-daterange-picker";
  import "vue-loading-overlay/dist/vue-loading.css";
  import DatePicker from "vue2-datepicker";
  import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
  import { globalPermissionStatus } from "../../helper/collection";

  export default {
    beforeMount() {
      if (globalPermissionStatus("Sea Freight")) {
        this.$store.dispatch("setCurrentRoute", "/Freight/freightReports");
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("QuotationAssignment")
        );
        this.viewAssignment("0", "1", "1");
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
    },
    data() {
      return {
        seriesExDesti: [
          {
            name: "No. of Containers",
            data: [],
          },
        ],
        chartOptionsExDesti: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              columnWidth: "50%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 2,
          },

          grid: {
            row: {
              colors: ["#fff", "#f2f2f2"],
            },
          },
          xaxis: {
            labels: {
              rotate: -45,
            },
            categories: [],
            tickPlacement: "on",
          },
          yaxis: {
            title: {
              text: "No. of Containers",
            },
          },
          fill: {
            type: "",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 1,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.85,
              opacityTo: 0.85,
              stops: [50, 0, 100],
            },
          },
        },
        seriesRefuel: [
          {
            name: "No. of Containers Executed",
            data: [],
          },
        ],
        chartOptionsRefuel: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              columnWidth: "50%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 2,
          },

          grid: {
            row: {
              colors: ["#fff", "#f2f2f2"],
            },
          },
          xaxis: {
            labels: {
              rotate: -45,
            },
            categories: [],
            tickPlacement: "on",
          },
          yaxis: {
            title: {
              text: "No. of Containers Executed",
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              type: "horizontal",
              shadeIntensity: 0.25,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.85,
              opacityTo: 0.85,
              stops: [50, 0, 100],
            },
          },
        },
        showGraph: false,
        fieldsV: [
          {
            key: "vehicleTruckId",
            label: "Sr No.",
            sortable: true,
            sortDirection: "desc"
          },
          {
            key: "regdNo",
            label: "Vehicle No.",
            sortable: true,
            sortDirection: "desc"
          },

          {
            key: "noOfTripscount",
            label: " No. Of Trips",
            sortable: true,
            sortDirection: "desc"
          },



          {
            key: "sumDieselUsed",
            label: " Diesel Consumed (Ltr's)",
            sortable: true,
            sortDirection: "desc"
          }

        ],
        totalVehicleCount: "",
        availVehicleCount: "",
        bookVehicleCount: "",
        currentPageV: 1,
        perPageV: 10,
        totalRowsV: "",
        pageOptionsV: [5, 10, 15],
        sortByV: null,
        sortDescV: false,
        sortDirectionV: "desc",
        filterV: null,
        modalInfo: { title: "", content: "" },
        clientMaster: [],
        topTPTClientRevenue: [],
        vehicleReports: [],
        clientIdFilter: "",
        transportTypeFilter: "",
        transportTypeName: [
          {
            transportTypeVal: "Export",
            transportTypeText: "Export"
          },
          {
            transportTypeVal: "Import",
            transportTypeText: "Import"
          }
        ],
        reload: true,

        visible: false,
        startDate: "2017-09-05",
        endDate: "2017-09-15",
        openLeft: "left",
        showCal: false,
        dateRange: {},
        locale: {
          direction: "ltr",
          format: "mm/dd/yyyy",
          separator: " - ",
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          monthNames: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          firstDay: 0
        },
        totalRows: "",
        currentPage: 1,
        perPage: 10,
        pageOptions: [20, 50, 100],
        sortBy: null,
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        docURL: URL_BASE_DOC,
        fields: [
          {
            key: "ffImportId",
            mainkey: "ffImportId",
            label: "Sr No.",
            sortable: true,
            sortDirection: "ASC"
          },
          {
            key: "importerName",
            mainkey: "importerName",
            label: "Client / Shipper Name",
            sortable: true,
            width: "500px",
            sortDirection: "ASC"
            //  table: "B."
          },
          {
            key: "ffImportSeries",
            mainkey: "ffImportSeries",
            label: "Assignment No.",
            sortable: true,
            sortDirection: "ASC"
            // table: "P."
          },



          {
            key: "placeOfReceipt",
            mainkey: "placeOfReceipt",
            label: " Location",
            sortable: true,
            sortDirection: "ASC"
            //  table: "B."
          },
          // {
          //   key: "LoadPort",
          //   mainkey: "LoadPort",
          //   label: "Required Container",
          //   sortable: true,
          //   sortDirection: "ASC"
          //   //   table: "D."
          // },


          {
            key: "ContainerNo",
            mainkey: "ContainerNo",
            label: "Container No.",
            sortable: true,
            sortDirection: "ASC"
            //   table: "D."
          },
          {
            key: "containerTypeName",
            mainkey: "containerTypeName",
            label: "Container Type",
            sortable: true,
            sortDirection: "ASC"
          },
          // {
          //   key: "shippingBillNo",
          //   mainkey: "shippingBillNo",
          //   label: "SB No.",
          //   sortable: true,
          //   sortDirection: "ASC"
          // },


        ],
        NoOfAssignment: "",
        isLoading: false,
        viewAssignment1: [],
        veiwVehicleBookingForm: []
      };
    },

    filters: {
      moment(date) {
        return DateFormat(date)
      }
    },

    mounted() { },
    beforeDestroy() { },
    destroyed() { },
    components: {
      ModelListSelect,
      // Loading,
      CustomLoader,
      DateRangePicker
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fieldsV
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key };
          });
      }
    },

    methods: {
      onFilteredV(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRowsV = filteredItems.length;
        this.currentPageV = 1;
      },
      filterSearch() {
        this.reload = false;
        this.viewAssignment("0", "1", "1");
      },
      clearFilter() {

        this.clientIdFilter = "";
        this.transportTypeFilter = "";
        this.dateRange = ""
        this.viewAssignment("0", "1", "1");
      },
      getReports() {

        let view_Assignment = {
          excelId: "FF_IMPORT",
          dateRange: this.dateRange,
          clientIdFilter: this.clientIdFilter,
          transportTypeFilter: this.transportTypeFilter,

        };
        console.log(view_Assignment);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
          data: JSON.stringify(view_Assignment),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {

if(data.excelName!=undefined){


              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName

}
              //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

              // console.log(abc)



            }
          })
          .catch(error => { });


      },
      onPageChange: function (event) {
        let CURRENT = 0;
        if (event == "1") {
          CURRENT = 0;
        } else {
          CURRENT = event * this.perPage - this.perPage;
        }

        this.viewAssignment(CURRENT, "2", event);

        // let totalRows = 1064 / this.perPage;
        // if(this.totalRow )
      },
      viewVBookingPage(
        clientId,
        salesid,
        quotationId,
        assignId,
        vBookingId,
        followUpId
      ) {
        this.$sessionsStorage.set("clientId", clientId);
        this.$sessionsStorage.set("salesBookingId", salesid);
        this.$sessionsStorage.set("storeQuotationId", quotationId);
        this.$sessionsStorage.set("storeAssignId", assignId);
        this.$sessionsStorage.set("storeVehicleBookingId", vBookingId);
        if (followUpId == "" || followUpId == null) {
          this.$sessionsStorage.set("storefollowActivityId", "false");
        } else {
          this.$sessionsStorage.set("storefollowActivityId", followUpId);
        }

        this.$router.push({
          path: "/vehicle/vehicleBooking"
        });
      },
      goToTrack(AId) {
        this.$sessionsStorage.set("storeAssignId", AId);
        this.$sessionsStorage.set("backToDetailPage", "22");
        this.$router.push({
          path: "/vehicleQuotation/tranportMailDetails"
        });
      },
      goToMain() {
        this.$router.push({
          path: "/sales/salesBooking"
        });
      },
      doLoading() {
        this.isLoading = true;
      },
      doLoadingClose() {
        this.isLoading = true;

        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      },

      JqueryFun() {
        return $(function () {
          return $("#viewVehicleBooking21212").DataTable();
        });
      },

      viewAssignmentpage(clientId, salesid, quotationId, assignId) {
        this.$sessionsStorage.set("storeAssignId", assignId);
        this.$sessionsStorage.set("clientId", clientId);
        this.$sessionsStorage.set("salesBookingId", salesid);
        this.$sessionsStorage.set("storeQuotationId", quotationId);
        this.$router.push({
          path: "/vehicle/vehicleBooking"
        });
      },

      viewAssignment(CURRENT, SEARCH, pageNumber, clear) {
        this.isLoading = true;
        this.showGraph = false;
        this.veiwVehicleBookingForm = []
        this.chartOptionsRefuel.xaxis.categories = [];
        this.seriesRefuel[0].data = [];
        this.chartOptionsExDesti.xaxis.categories = [];
        this.seriesExDesti[0].data = [];
        let dummyObj = ''
        if (clear == 'clear') {
          dummyObj = ""
        } else {
          dummyObj = this.dateRange
        }
        let view_Assignment = {
          searchVal: this.filter,
          fields: this.fields,
          fromSearch: SEARCH,
          currentPage: CURRENT,
          perPage: this.perPage,
          assignmentNo: "assignmentNo",
          dateRange: dummyObj,
          clientIdFilter: this.clientIdFilter,
          transportTypeFilter: this.transportTypeFilter,
        };
        console.log(view_Assignment);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Reports/getFFImportReports.php`,
          data: JSON.stringify(view_Assignment),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              console.log(data);

              if (SEARCH != "2") {
                this.currentPage = 1;
                this.totalRows = data.totalData;
              } else {
                this.currentPage = pageNumber;
              }

              if (data.booking.length > 0) {
                this.veiwVehicleBookingForm = data.booking;
              }
              if (this.reload == true) {

                if (data.clientMaster.length > 0) {
                  this.clientMaster = data.clientMaster;
                }

              }

              if (data.topClientNameContainerExec.length > 0) {
                this.chartOptionsRefuel.xaxis.categories = data.topClientNameContainerExec
                this.seriesRefuel[0].data = data.topClientContainerExecCount
              }
              if (data.topExportDestinationName.length > 0) {
                this.chartOptionsExDesti.xaxis.categories = data.topExportDestinationName
                this.seriesExDesti[0].data = data.topExportDestinationContainerExecCount

              }


              this.showGraph = true;

              this.isLoading = false;
            }
          })
          .catch(error => { });
      }
    }
  };
</script>
<style>
.md-theme-default.md-tabs>.md-tabs-navigation {
  background-color: #ffffff;
}
.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header.md-active, .md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header:focus {
  color: #625f6e;
}
.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header{
  color: #625f6e;
}
.md-theme-default.md-tabs > .md-tabs-navigation .md-tab-indicator {
  background-color: #002a48;
  height: 4px;
  border-radius: 10px;
}
.md-whiteframe {
  background: #fff;
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border-radius: 0.423rem;
}
</style>


// WEBPACK FOOTER //
// freightImportReports.vue?1af9d96d